import "bootstrap/dist/css/bootstrap.min.css";

import { useState } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

import "./App.css";

import { Spinner } from "react-bootstrap";
import TopBanners from "./Component/TopBanners";
import Feedback from "./Component/Feedback";
import Home from "./Component/Home";
import Layout from "./Component/Layout";
import PageTracker from "./Component/PageTracker";
import useServerStatus from "./hooks/useServerStatus";

const ELITEALARMS_URL = "https://elitealarms.com";
const DASHBOARD_URL = "https://dashboard.elitealarms.com";


const SpinnerCentered = () => {
  return (
    <div style={{ width: "100%", height: "100dvh", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Spinner animation="border" role="status" style={{ color: "#4980be" }}>
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  )
}

function App() {
  const { message } = useServerStatus();
  const [topBannerOffset, setTopBannerOffset] = useState(50);

  return (
    <>
      <TopBanners
        serverMessage={message}
        onHeightChange={setTopBannerOffset}
      />
      <Router>
        <PageTracker />
        <Switch>
          <Route exact path={"/manuals/installer"} render={() => {
            window.location.href = `${ELITEALARMS_URL}/manuals/installer`;
            return <SpinnerCentered />
          }} />
          <Route exact path={"/sim"} render={() => {
            window.location.href = `${DASHBOARD_URL}/account/sim`
            return <SpinnerCentered />
          }} />
          <Layout topBannerOffset={topBannerOffset}>
            <Route exact path={"/"} render={() => <Home message={message} />} />
            {/* <Route
              exact
              path={"/upgrade"}
              render={() => <Upgrade message={message} />}
            /> */}
            <Route
              exact
              path={"/feedback"}
              render={() => <Feedback message={message} />}
            />
          </Layout>
          {/* <Route exact path={"/scroll"} component={ScrollIndicator} />
          <Route exact path={"/pricing"} component={Pricing} />
          <Route exact path={"/appslider"} component={AppSlider} />
          <Route exact path={"/mail"} component={EmailPops} /> */}
        </Switch>
      </Router>
    </>
  );
}

export default App;
